module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACcSURBVHgBfZBhEcMgDIUTqJBJmIUK4I4pWB3UwiRsDuZgDATMAlKmAPrSa+7aXkv+EB55H0mYEM65gZkvktda/ymlJ+3CSJExZlTBWktH0QkJlG+M8bF+8N5f5Qwh5JlIjQDgo4ZuTymleMlxEn7LKP5B75vETY/ry9JPVjpod1B70ZtEFN10GIZzgHOUyZcBjvcIxxvOlwpne5wANtdHBs4amLwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logout.png
// module id = /wuy
// module chunks = 1